"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  extractPlasmicQueryData: () => extractPlasmicQueryData,
  plasmicPrepass: () => plasmicPrepass,
  plasmicPrepassExtract: () => plasmicPrepassExtract
});
module.exports = __toCommonJS(src_exports);
var import_query = require("@plasmicapp/query");
var import_react_ssr_prepass = __toESM(require("@plasmicapp/react-ssr-prepass"));
var import_react = __toESM(require("react"));
async function plasmicPrepassExtract(element, onClientComponentRef) {
  const cache = /* @__PURE__ */ new Map();
  const headMetadata = {};
  try {
    await plasmicPrepass(
      /* @__PURE__ */ import_react.default.createElement(import_query.PlasmicPrepassContext, { cache }, /* @__PURE__ */ import_react.default.createElement(import_query.HeadMetadataContext.Provider, { value: headMetadata }, element)),
      onClientComponentRef
    );
  } catch (err) {
    console.warn(`PLASMIC: Error encountered while pre-rendering`, err);
  }
  const filteredCache = Object.fromEntries(
    Array.from(cache.entries()).filter(
      ([key, val]) => !key.startsWith("$swr$") && !key.startsWith("$csq$") && val !== void 0
    )
  );
  const queryData = (() => {
    try {
      return JSON.parse(
        JSON.stringify(
          filteredCache,
          (_key, value) => value !== void 0 ? value : null
        )
      );
    } catch {
      return filteredCache;
    }
  })();
  return {
    queryData,
    headMetadata
  };
}
async function extractPlasmicQueryData(element, onClientComponentRef) {
  return (await plasmicPrepassExtract(element, onClientComponentRef)).queryData;
}
async function plasmicPrepass(element, onClientComponentRef) {
  await (0, import_react_ssr_prepass.default)(element, void 0, onClientComponentRef);
}
